import React, { useEffect, useRef } from 'react';
import image1 from "../../images/employeeImages/image-1.jpg";
import image2 from "../../images/employeeImages/image-2.jpg";
import image3 from "../../images/employeeImages/image-3.jpg";
import image4 from "../../images/employeeImages/image-4.jpg";
import image5 from "../../images/employeeImages/image-5.jpg";

const TeamMember = () => {
    const containerRef = useRef(null);
    const animationRef = useRef(null);
    const translateX = useRef(0);

    const teamMembers = [
        {
            image: image1,
            name: "Sriram Singh",
            designation: "CTO",
        },
        {
            image: image2,
            name: "Prince Anand",
            designation: "Managing Director",
        },
        {
            image: image3,
            name: "Pratyush",
            designation: "CLO",
        },
        {
            image: image4,
            name: "Aryan",
            designation: "Co-Founder",
        },
        {
            image: image5,
            name: "Brajesh",
            designation: "Co-Founder",
        },
    ];

    const members = [...teamMembers, ...teamMembers]; // Duplicate for smooth loop

    useEffect(() => {
        const container = containerRef.current;
        let speed = 1.05;

        const animate = () => {
            translateX.current -= speed;
            if (container) {
                const maxScroll = container.scrollWidth / 2;
                if (Math.abs(translateX.current) >= maxScroll) {
                    translateX.current = 0;
                }
                container.style.transform = `translateX(${translateX.current}px)`;
            }
            animationRef.current = requestAnimationFrame(animate);
        };

        animationRef.current = requestAnimationFrame(animate);

        return () => cancelAnimationFrame(animationRef.current);
    }, []);

    return (
        <div className="overflow-hidden bg-white py-10">
            <h2 className="text-4xl font-bold text-center mb-8">Meet Our Team</h2>
            <div className="relative overflow-hidden px-4">
                <div className="w-full overflow-hidden sm:w-auto">
                    <div
                        ref={containerRef}
                        className="flex space-x-6"
                        style={{
                            whiteSpace: "nowrap",
                            transition: "transform 0.1s linear",
                            willChange: "transform",
                        }}
                    >
                        {members.map((member, i) => (
                            <div
                                key={i}
                                className="flex-shrink-0 w-64 h-80 bg-white shadow-lg rounded-2xl p-4 flex flex-col items-center justify-center text-center"
                            >
                                <img
                                    src={member.image}
                                    alt={member.name}
                                    className="w-32 h-32 rounded-full object-cover mb-4"
                                />
                                <h3 className="text-xl font-semibold">{member.name}</h3>
                                <p className="text-gray-500">{member.designation}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TeamMember;
